export const buildFiltersParams = (filters = {}) =>
    Object.fromEntries(
        Object.entries(filters).filter(
            ([key, value]) =>
                // pomijamy isVisible === false
                !(key === 'isVisible' && value === false)
        )
    )
